import { render, staticRenderFns } from "./typeList.vue?vue&type=template&id=21a54f4c&scoped=true"
import script from "./typeList.vue?vue&type=script&lang=js"
export * from "./typeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a54f4c",
  null
  
)

export default component.exports